var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-auto",staticStyle:{"max-height":"30vh"}},[_c('ts-table',{attrs:{"columns":_vm.columns,"records":_vm.resources,"loading":_vm.loading,"rowGroup":{
      field: 'branch.branch_name_en'
    }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var record = ref.record;
return [_c('td',[_vm._v("\n        "+_vm._s(record.year ? record.year.ac_year : '')+"\n      ")]),_c('td',[_vm._v(_vm._s(record.class_name))]),_c('td',[_vm._v("\n        "+_vm._s(record.grade ? record.grade.grade_name_foreign : '')+"\n      ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }